import FullWidthLayout from "@/layouts/FullWidthLayout";
import WorkOrdersTable from "kinnect-front/FacilityMaintenance/WorkOrders/WorkOrdersTable";
import { Pageable } from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import { VCard, VSheet } from "vuetify/lib";

export default {
	name: "FacilityMaintenanceCompletedWorkOrdersPage",

	metaInfo: { title: "Facility Maintenance - Completed Work Orders" },

	mixins: [ Pageable ],

	data: () => ( {
		search: ""
	} ),

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<WorkOrdersTable
					itemsFilter={item => item.completed}
					modifyItemsQuery={query => query.where( "completed", true )}
					search={this.search}
				></WorkOrdersTable>
			</VCard>
		</FullWidthLayout>;
	}
};
